import * as yup from "yup";

export class SachbezugDivision {
	private constructor(
		readonly divisionId: string,
		readonly isFitnessEnabled: boolean
	) {}

	private static schema = yup.object({
		divisionId: yup
			.string()
			.uuid("Invalid divisionId")
			.required("divisionId is required"),
		isFitnessEnabled: yup.boolean().required("isFitnessEnabled is required"),
	});

	static fromJson(obj: any) {
		const { divisionId, isFitnessEnabled } = this.schema.validateSync(obj);
		return new SachbezugDivision(divisionId, isFitnessEnabled);
	}

	toUpdatePayload() {
		return {
			isFitnessEnabled: this.isFitnessEnabled,
		};
	}
}
